import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import moment from 'moment';

export const exportStyledTableToXLSX = (data, selectedRows, fileName = 'tabela_pedidos.xlsx') => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Orders');

    worksheet.columns = [
        { header: 'Pedido', key: 'partnerId', width: 15 },
        { header: 'Partner ID', key: 'partnerProductId', width: 20 },
        { header: 'SKU', key: 'skuPartnerId', width: 20 },
        { header: 'Itens', key: 'items', width: 10 },
        { header: 'Marketplace', key: 'marketPlace', width: 20 },
        { header: 'Status', key: 'status', width: 20 },
        { header: 'Total', key: 'total', width: 15 },
        { header: 'Desconto', key: 'discount', width: 15 },
        { header: 'Frete Pago', key: 'freight', width: 15 },
        { header: 'Total Produto', key: 'totalProduto', width: 15 },
        { header: 'Frete Gratis', key: 'sellerFreight', width: 15 },
        { header: 'Total CVM', key: 'totalCvm', width: 15 },
        { header: 'Comissão', key: 'comission', width: 15 },
        { header: 'Imposto', key: 'impostoTotal', width: 15 },
        { header: 'ICMS Difal', key: 'icmsDifal', width: 15 },
        { header: 'ICMS Total SKU', key: 'icmsTotalSku', width: 15 },
        { header: 'Total Imp PIS Cofins', key: 'totalImpPisCofins', width: 15 },
        { header: 'VPC', key: 'vpc', width: 15 },
        { header: 'Reembolso', key: 'rmb', width: 15 },
        { header: 'Taxa Fixa', key: 'txFixa', width: 15 },
        { header: 'Cupom Vendedor', key: 'sellerCoupon', width: 15 },
        { header: '= Margem', key: 'equalMar', width: 15 },
        { header: '% Margem', key: 'percentMar', width: 15 },
        { header: 'Estado', key: 'state', width: 15 },
        { header: 'Data de Criação', key: 'createdAt', width: 20 },
    ];

    worksheet.getRow(1).eachCell(cell => {
        cell.font = { bold: true, color: { argb: 'FFFFFF' } };
        cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: '34495E' },
        };
        cell.alignment = { horizontal: 'center', vertical: 'middle' };
    });

    worksheet.getRow(1).height = 40;

    selectedRows.forEach((rowIndex, idx) => {
        const row = data[rowIndex];
        worksheet.addRow({
            partnerId: `${row.partnerId}`,
            partnerProductId: row.items?.map(item => item.product?.id).filter(id => id).join(',') || '',
            skuPartnerId: row.items?.map(item => item.sku?.partnerId).filter(id => id).join(',') || '',
            items: row.items.length,
            marketPlace: row.marketPlace,
            status: row.status,
            total: `R$ ${row.total.toFixed(2).replace('.', ',')}`,
            discount: `R$ ${row.discount.toFixed(2).replace('.', ',')}`,
            freight: `R$ ${row.freight.toFixed(2).replace('.', ',')}`,
            totalProduto: `R$ ${row.totalProduto?.toFixed(2).replace('.', ',')}`,
            sellerFreight: `R$ ${row.sellerFreight.toFixed(2).replace('.', ',')}`,
            totalCvm: `R$ ${row.totalCvm?.toFixed(2).replace('.', ',')}`,
            comission: `R$ ${Number(row.comission).toFixed(2).replace('.', ',') || '0,00'}`,
            impostoTotal: `R$ ${row.impostoTotal?.toFixed(2).replace('.', ',')}`,
            icmsDifal: `R$ ${row.icmsDifal?.toFixed(2).replace('.', ',') || '0,00'}`,
            icmsTotalSku: `R$ ${(row.items?.map(item => item.icms === "Sku Not Found" ? 0 : (item.icms || 0)).reduce((acc, cur) => acc + cur, 0) || 0).toFixed(2).replace('.', ',')}`,
            totalImpPisCofins: `R$ ${row.totalImpPisCofins?.toFixed(2).replace('.', ',') || '0,00'}`,
            vpc: `R$ ${row.vpc?.toFixed(2).replace('.', ',') || '0,00'}`,
            rmb: `R$ ${row.rmb?.toFixed(2).replace('.', ',') || '0,00'}`,
            txFixa: `R$ ${row.txFixa?.toFixed(2).replace('.', ',') || '0,00'}`,
            sellerCoupon: `R$ ${row.sellerCoupon?.toFixed(2).replace('.', ',') || '0,00'}`,
            percentMar: `${row.percentMar?.toFixed(2).replace('.', ',')}%`,
            equalMar: `R$ ${row.equalMar?.toFixed(2).replace('.', ',')}`,
            state: row.shipping?.state,
            createdAt: moment(row.createdAt).format('DD/MM/YYYY HH:mm:ss'),
        });

        const currentRow = worksheet.getRow(idx + 2);
        const isEven = idx % 2 === 0;
        currentRow.eachCell((cell, colNumber) => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: isEven ? 'FFFFFF' : 'F2F2F2' },
            };

            cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };

            if (colNumber === 7 || colNumber === 8 || colNumber === 9 || colNumber === 10 || colNumber === 11 || colNumber === 12 || colNumber === 13 || colNumber === 14 || colNumber === 15 || colNumber === 16 || colNumber === 17 || colNumber === 18 || colNumber === 19 || colNumber === 20) {
                cell.numFmt = '"R$ "#,##0.00';
            } else if (colNumber === 22 || colNumber === 23) {
                cell.numFmt = '0.00%';
            }

            if (colNumber === 12 || colNumber === 13 || colNumber === 14 || colNumber === 15 || colNumber === 16 || colNumber === 20 || colNumber === 21) {
                cell.font = { color: { argb: '#fc3434' } };
            }

            if (colNumber === 22 || colNumber === 23) { 
                const percentMarValue = row.percentMar;
                if (percentMarValue < 0) {
                    cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'efb5b9' } };
                    cell.font = { color: { argb: '#fc3434' } };
                } else if (percentMarValue < 5) {
                    cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'f2cea7' } };
                    cell.font = { color: { argb: 'black' } };
                } else if (percentMarValue < 10) {
                    cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'caf5c1' } };
                    cell.font = { color: { argb: '#2e31ff' } };
                } else {
                    cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'DEEEFF' } };
                    cell.font = { color: { argb: '#2e31ff' } };

                }
            }
        });
    });

    workbook.xlsx.writeBuffer().then(buffer => {
        saveAs(new Blob([buffer]), fileName);
    });
};
